/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DynamoDbBackupConfig } from '../models/DynamoDbBackupConfig';

export class ListDynamoDbBackupConfigsResponse {
  /**
  * List of DynamoDB backup configurations
  */
  'configs': Array<DynamoDbBackupConfig>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "configs",
      "baseName": "configs",
      "type": "Array<DynamoDbBackupConfig>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListDynamoDbBackupConfigsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

